import * as React from 'react';
import { connect } from 'react-redux';
import { Selectors as AuthSelectors } from 'services/authentication';
import { State } from 'store';
import Router from './router';

interface StateProps {
  mfaMethod: string;
}
interface InheritedProps {
  authState: string;
}
type Props = InheritedProps & StateProps;

export const CheckMFA: React.FC<Props> = props => {
  return (
    <>
      {/* When mfaRequired is added to the userProfileData, a check will need to be added in here: 
          if props.authState === 'signedIn' && mfaRequired === true && mfaMethod === 'NOMFA', 
            show TOTPSetup screen
          else
            show router and dashboard
      */}
      {props.authState === 'signedIn' ? <Router /> : null}
    </>
  );
};

export function mapStateToProps(state: State): StateProps {
  return {
    mfaMethod: AuthSelectors.getPreferredMfaMethod(state),
  };
}

export default connect(mapStateToProps)(CheckMFA);
